import { apiClient } from './api-client';
import type {
  DashboardMetrics,
  JobReportMetrics,
  RecruiterMetrics,
  RecruiterDetailMetrics,
  PlatformMetrics,
  ExportRequest,
  ExportRecord,
} from '@recruitai/shared';

function dateParams(startDate: string, endDate: string): string {
  return `?startDate=${startDate}&endDate=${endDate}`;
}

export const reportsApi = {
  fetchDashboardMetrics: (startDate: string, endDate: string) =>
    apiClient.get<DashboardMetrics>(`/reports/dashboard${dateParams(startDate, endDate)}`),

  fetchJobReport: (jobId: string, startDate: string, endDate: string) =>
    apiClient.get<JobReportMetrics>(`/reports/jobs/${jobId}${dateParams(startDate, endDate)}`),

  fetchRecruitersReport: (startDate: string, endDate: string) =>
    apiClient.get<RecruiterMetrics[]>(`/reports/recruiters${dateParams(startDate, endDate)}`),

  fetchRecruiterDetail: (userId: string, startDate: string, endDate: string) =>
    apiClient.get<RecruiterDetailMetrics>(`/reports/recruiters/${userId}${dateParams(startDate, endDate)}`),

  fetchPlatformReport: (startDate: string, endDate: string) =>
    apiClient.get<PlatformMetrics>(`/reports/platform${dateParams(startDate, endDate)}`),

  requestExport: (request: ExportRequest) =>
    apiClient.post<ExportRecord>('/reports/export', request),

  fetchExportStatus: (exportId: string) =>
    apiClient.get<ExportRecord>(`/reports/export/${exportId}`),
};
